import { render, staticRenderFns } from "./company-join.vue?vue&type=template&id=2e5beaa8&scoped=true"
import script from "./company-join.vue?vue&type=script&lang=js"
export * from "./company-join.vue?vue&type=script&lang=js"
import style0 from "./company-join.vue?vue&type=style&index=0&id=2e5beaa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5beaa8",
  null
  
)

export default component.exports